// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"ccb912df","787":"cc7550ff"}[chunkId] + ".chunk.js";
};